import React, { Component, version } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Button,
} from "@material-ui/core";
import AppBarModal from '../../../general/AppBarModal';
import TareasTerminadas from '../../../general/TareasTerminadas';
import { obtenerValoresFiltros, obtenerMisDatos } from "../../../../global/js/funciones";
import emma_w from '../../../../global/imagenes/emma_w.png';
import { MODALIDAD_ASESORIA, TIPOS_ASESORIA, TIPOS_FORMAS_ASESORIAS, PARENTESCOS_BIENESTAR, PROTECCION_DATOS_BIENESTAR, CONSENTIMIENTO_GENERAL, CONSENTIMIENTO_CRISIS } from '../../helper';
import { FormularioAsistencia } from './FormularioAsistencia';
import { FormularioSatisfaccion } from './FormularioSatisfaccion';
import { FormularioDisentimientoInformado } from './FormularioDisentimientoBienestar';
import { FormularioDisentimientoTrasladoEPS } from './FormularioDisentimientoTrasladoEPSBienestar';
import { FormularioConsentimientoGeneral, FormularioConsentimientoCrisis, TextoConsentimiento } from './FormularioConsentimientos';
import { FormularioMaestroFasesConAcciones } from './fases/FormularioMaestroFases';
import { FormularioFichaSeguimientoConAcciones, FormularioFichaSeguimientoMaestro } from './fichas/FormularioFichaSeguimiento';
import { ProteccionDatos } from '../components/BienestarTextoLegal';
import { procesarFirmas, procesarFirmasEstudianteAcudiente } from './pdf/procesarFirmas';
import {
    fetchProfesionalesBienestar,
    postFormatoBienestar,
} from '../services/bienestarDetalleService';

const FORMATO_BIENESTAR_DIALOG_PAPER = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 16px)',
    margin: 8,
    width: 'calc(100vw - 16px)',
    maxWidth: 960,
};

class BienestarFormFormatos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            tipoFormulario: null,
            tituloFormulario: "",
            version: "",
            mes: "",
            trd:"",
            
            // Campos comunes
            acepta_terminos: { valor: false, error: "" },
            acepta_proteccion_datos: false,
            programa_opciones: [],
            modalidad_opciones: [],
            tipo_asesoria_opciones: [],
            tipo_asesoria_consent_opciones: [],
            forma_asesoria_opciones: [],
            parentesco_opciones: [],
            profesionales_opciones: [],
            modalidadAutoLlenada: false,
            texto_proteccion_datos : "",
            texto_consentimiento_general : {
                descripcion: "",
                titulo: "",
                aceptacion: ""
            },
            texto_consentimiento_crisis : {
                descripcion: "",
                titulo: "",
                aceptacion: ""
            },
            
            // Campos formulario de asistencia
            nombre_completo: { valor: "", error: "" },
            programa: { valor: "", error: "" },
            documento: { valor: "", error: "" },
            celular: { valor: "", error: "" },
            modalidad: { valor: "", error: "" },
            tipo_asesoria: { valor: "", error: "" },
            forma_asesoria: { valor: "", error: "" },
            funcionario_paspe: { valor: "", nombre: "", error: "" },
            
            // Campos formulario de satisfacción
            p1_satisfaccion: { valor: "", error: "" },
            p1_comentario_satisfaccion: { valor: "", error: "" },
            p2_temas_pertinentes: { valor: "", error: "" },
            p2_comentario_temas: { valor: "", error: "" },
            p3_estrategias_utiles: { valor: "", error: "" },
            p3_comentario_estrategias: { valor: "", error: "" },
            p4_comunicacion: { valor: "", error: "" },
            p4_comentario_comunicacion: { valor: "", error: "" },
            p5_formacion_integral: { valor: "", error: "" },
            p5_comentario_formacion: { valor: "", error: "" },
            p6_atencion_servicio: { valor: "", error: "" },
            p6_comentario_atencion: { valor: "", error: "" },
            p7_bienestar_emocional: { valor: "", error: "" },
            p7_comentario_bienestar: { valor: "", error: "" },
            p8_mejoras: { valor: "", error: "" },
            
            // Campos formulario de consentimiento
            tipo_asesoria_individual: { valor: "", error: "" },
            tipo_asesoria_consentimiento: { valor: "", error: "" },
            nombre_completo_consent: { valor: "", error: "" },
            identificacion_consent: { valor: "", error: "" },
            celular_consent: { valor: "", error: "" },
            contacto_emergencia_1: { valor: "", error: "" },
            celular_contacto_1: { valor: "", error: "" },
            parentesco_contacto_1: { valor: "", error: "" },
            contacto_emergencia_2: { valor: "", error: "" },
            celular_contacto_2: { valor: "", error: "" },
            parentesco_contacto_2: { valor: "", error: "" },
            consentimiento_aceptado: { valor: false, error: "" },
            consentimiento_aceptado_crisis: { valor: false, error: "" },
            disentimientoInformado: { valor: "", error: "" },
            paso_disentimiento: 0,
            paso_disentimiento_traslado_eps: 0,

        };

        this.firmaDisentimientoAcudiente = React.createRef();
        this.firmaTrasladoEstudiante = React.createRef();
        this.firmaTrasladoAcudiente = React.createRef();
    }

    limpiarFirmaCanvas = (ref) => {
        if (ref && ref.current) {
            ref.current.clear();
        }
    };


    esFormularioValido = () => {
        const fases = [
            'F1_001', 'F2_002', 'F2_003', 'F2_004', 'F2_005',
            'F3_006', 'F5_007', 'F5_008', 'F6_009',
            'T_1', 'T_2', 'T_3', 'T_4', 'T_5', 'ficha_seguimiento'
        ];
        const tipo = this.props.tipoFormulario || this.state.tipoFormulario;
        return fases.includes(tipo);
    };


    esPaspe = () => {
        const ts = this.props.tipoSolicitud;
        const code = (typeof ts === 'object' ? ts?.codigo : ts) || '';
        const val = String(code || '').toLowerCase();
        return val.includes('paspe');
    };


    esRemitente = () => {
        const ts = this.props.tipoSolicitud;
        const code = (typeof ts === 'object' ? ts?.codigo : ts) || '';
        const val = String(code || '').toLowerCase();
        return val.includes('rem');
    };


    resolverTipoFormulario = (tipoFormulario, sesion) => {
        let tipo = tipoFormulario || 'asistencia';
        if (tipo !== 'consentimiento') return tipo;
        const tipoServicio = this.props.tipoServicio || {};
        const normalizar = (v = '') => v.toLowerCase();
        const contieneCrisis = (nombre = '', codigo = '') =>
            normalizar(nombre).includes('crisis') ||
            normalizar(codigo).includes('crisis');
        const esCrisisServicio = contieneCrisis(
            tipoServicio.nombre || tipoServicio.valor,
            tipoServicio.codigo
        );
        const esCrisisSesion = contieneCrisis(
            sesion?.nombre,
            sesion?.codigo
        );
        if (esCrisisServicio || esCrisisSesion) {
            tipo = 'consentimiento_crisis';
        }
        return tipo;
    };


    obtenerFuncionarioAsignado = (agendamiento = {}) => {
        if (!agendamiento || typeof agendamiento !== 'object') return "";
        const prof = agendamiento.profesional_asignado;
        if (!prof) return "";
        
        if (typeof prof === 'string' || typeof prof === 'number') {
            return String(prof);
        }
        if (typeof prof === 'object') {
            if (prof.nombre_completo && prof.nombre_completo.trim()) return prof.nombre_completo.trim();
            const nombre = [prof.primer_nombre, prof.segundo_nombre, prof.primer_apellido, prof.segundo_apellido]
                .filter(Boolean)
                .join(' ')
                .trim();
            if (nombre) return nombre;
            if (prof.id) return String(prof.id);
        }
        return "";
    };


    async componentDidUpdate(prevProps) {
        const { modalOpen, tipoFormulario, sesion, solicitud, tipoServicio } = this.props;
        if (prevProps.modalOpen !== modalOpen && modalOpen) {
            const tipoResuelto = this.resolverTipoFormulario(tipoFormulario, sesion);
            this.setState({ tipoFormulario: tipoResuelto });
            await this.cargarDatosIniciales(tipoResuelto);
            if (tipoResuelto === 'ficha_seguimiento' && solicitud?.usuario_registro) {
                const nombreCompleto = [
                    solicitud.usuario_registro.primer_nombre,
                    solicitud.usuario_registro.segundo_nombre,
                    solicitud.usuario_registro.primer_apellido,
                    solicitud.usuario_registro.segundo_apellido
                ].filter(Boolean).join(' ').trim();
                
                this.setState({
                    nombre_completo: { valor: nombreCompleto, error: "" },
                    documento: { valor: solicitud.usuario_registro.identificacion || "", error: "" },
                    celular: { valor: solicitud.usuario_registro.celular || "", error: "" },
                    correo_electronico: { valor: solicitud.usuario_registro.correo_personal || "", error: "" },
                });
            }
        }

        if (modalOpen && prevProps.tipoFormulario !== tipoFormulario) {
            const tipoResuelto = this.resolverTipoFormulario(tipoFormulario, sesion);
            this.resetState(async () => {
                this.setState({ tipoFormulario: tipoResuelto });
                await this.cargarDatosIniciales(tipoResuelto);
            });
        }

        if (modalOpen && tipoFormulario === 'consentimiento' && prevProps.tipoServicio !== tipoServicio) {
            const tipoResuelto = this.resolverTipoFormulario(tipoFormulario, sesion);
            if (tipoResuelto !== this.state.tipoFormulario) {
                this.setState({ tipoFormulario: tipoResuelto });
            }
        }
    }


    cargarDatosIniciales = async (tipo) => {

        const construirNombreCompleto = (persona = {}) =>
            [
                persona.primer_nombre,
                persona.segundo_nombre,
                persona.primer_apellido,
                persona.segundo_apellido
            ].filter(Boolean).join(' ').trim();

        const mapOpciones = (arr) =>
            (Array.isArray(arr) ? arr : []).map(item => ({
                value: item.id || item.codigo || item.valor,
                label: item.nombre || item.valor || item.label || item.codigo || ""
            }));

        try {
            this.setState({ cargando: true });
            const misDatos = await obtenerMisDatos();
            const programas = (misDatos?.programas || []).map(prog => ({
                value: prog.relacion?.id || prog.id,
                label: prog.relacion?.nombre || prog.nombre
            }));

            const [
                modalidadesRaw,
                formasAsesoriasRaw,
                parentescosRaw,
                tipoAsesoriasAllRaw,
                tipoAsesoriasConsentRaw
            ] = await Promise.all([
                obtenerValoresFiltros([{ llave: 'generica', valor: MODALIDAD_ASESORIA }, { llave: 'estado', valor: 1 }]),
                obtenerValoresFiltros([{ llave: 'generica', valor: TIPOS_FORMAS_ASESORIAS }, { llave: 'estado', valor: 1 }]),
                obtenerValoresFiltros([{ llave: 'generica', valor: PARENTESCOS_BIENESTAR }, { llave: 'estado', valor: 1 }]),
                obtenerValoresFiltros([{ llave: 'generica', valor: TIPOS_ASESORIA }, { llave: 'estado', valor: 1 }]),
                obtenerValoresFiltros([{ llave: 'generica', valor: TIPOS_ASESORIA }, { llave: 'valora', valor: '2' }, { llave: 'estado', valor: 1 }])
            ]);

            const proteccionDatosArr = await obtenerValoresFiltros([{ llave: 'generica', valor: PROTECCION_DATOS_BIENESTAR }]);
            const textoConsentimientoGeneralArr = await obtenerValoresFiltros([{ llave: 'generica', valor: CONSENTIMIENTO_GENERAL }]);
            const textoConsentimientoCrisisArr = await obtenerValoresFiltros([{ llave: 'generica', valor: CONSENTIMIENTO_CRISIS }]);


            // Adaptar endpoint legacy (callback) a Promise para mantener flujo async
            const profesionalesRaw = await fetchProfesionalesBienestar();

            const modalidades = mapOpciones(modalidadesRaw);
            const formasAsesorias = mapOpciones(formasAsesoriasRaw);
            const parentescos = mapOpciones(parentescosRaw);
            const tipoAsesorias = mapOpciones(tipoAsesoriasAllRaw);
            const tipoAsesoriasConsent = mapOpciones(tipoAsesoriasConsentRaw);

            const profesionales = (Array.isArray(profesionalesRaw) ? profesionalesRaw : []).map(prof => ({
                value: String(prof.id || prof.codigo || prof.valor),
                label: construirNombreCompleto(prof) || prof.nombre || prof.valor || ""
            }));

            const nuevoEstado = {
                programa_opciones: programas,
                modalidad_opciones: modalidades,
                tipo_asesoria_opciones: tipoAsesorias,
                tipo_asesoria_consent_opciones: tipoAsesoriasConsent,
                forma_asesoria_opciones: formasAsesorias,
                parentesco_opciones: parentescos,
                profesionales_opciones: profesionales,
                cargando: false
            };

            const persona = misDatos?.persona || {};
            const nombreCompleto = construirNombreCompleto(persona);

            if (tipo === 'asistencia' || tipo === 'disentimiento' || tipo === 'disentimiento_traslado_eps') {
                nuevoEstado.nombre_completo = { valor: nombreCompleto, error: "" };
                nuevoEstado.documento = { valor: persona.identificacion || "", error: "" };
                nuevoEstado.celular = { valor: persona.celular || "", error: "" };

                if (programas.length > 0) {
                    nuevoEstado.programa = { valor: programas[0].value, error: "" };
                }

                const modalidadSesion = this.props.agendamientoData?.modalidad;
                if (modalidadSesion) {
                    const modalidadEncontrada = modalidades.find(m =>
                        String(m.value) === String(modalidadSesion?.id ?? modalidadSesion)
                        || m.label === modalidadSesion?.nombre
                    );

                    if (modalidadEncontrada) {
                        nuevoEstado.modalidad = { valor: modalidadEncontrada.value, error: "" };
                        nuevoEstado.modalidadAutoLlenada = true;
                    }
                }
                if (this.esPaspe()) {
                    const funcionarioSesion = this.obtenerFuncionarioAsignado(this.props.agendamientoData);
                    if (funcionarioSesion) {
                        const profesionalEncontrado = profesionales.find(p => 
                            p.label === funcionarioSesion || String(p.value) === String(funcionarioSesion)
                        );
                        
                        if (profesionalEncontrado) {
                            nuevoEstado.funcionario_paspe = {
                                valor: profesionalEncontrado.value,
                                nombre: profesionalEncontrado.label,
                                error: ""
                            };
                        } else {
                            nuevoEstado.funcionario_paspe = {
                                valor: funcionarioSesion,
                                nombre: funcionarioSesion,
                                error: ""
                            };
                        }
                    }
                } else {
                    nuevoEstado.funcionario_paspe = { valor: "", nombre: "", error: "" };
                }
            }

            if (tipo === 'consentimiento' || tipo === 'consentimiento_crisis') {
                nuevoEstado.nombre_completo_consent = { valor: nombreCompleto, error: "" };
                nuevoEstado.identificacion_consent = { valor: persona.identificacion || "", error: "" };
                nuevoEstado.celular_consent = { valor: persona.celular || "", error: "" };
            }

            const codigoProteccion =
            (tipo === 'disentimiento' || tipo === 'disentimiento_traslado_eps')
                ? 'pro_datos_bien_disen'
                : 'pro_datos_bien';

            const proteccionSeleccionada = proteccionDatosArr.find(
            p => p.codigo === codigoProteccion
            );

            nuevoEstado.texto_proteccion_datos = proteccionSeleccionada?.descripcion || "";
            nuevoEstado.texto_consentimiento_general = {
            descripcion: textoConsentimientoGeneralArr?.[0]?.descripcion || "",
            titulo: textoConsentimientoGeneralArr?.[0]?.nombre || "",
            aceptacion: textoConsentimientoGeneralArr?.[0]?.valora || "",
            };

            nuevoEstado.texto_consentimiento_crisis = {
            descripcion: textoConsentimientoCrisisArr?.[0]?.descripcion || "",
            titulo: textoConsentimientoCrisisArr?.[0]?.nombre || "",
            aceptacion: textoConsentimientoCrisisArr?.[0]?.valora || "",
            };

            this.setState(nuevoEstado);

        } catch (error) {
            this.setState({ cargando: false });
        }
    };


    onChange = (event) => {
        const { name, value, type, checked, error } = event.target;
        const { profesionales_opciones } = this.state;
        
        if (name === 'funcionario_paspe') {
            const profesionalSeleccionado = profesionales_opciones?.find(p => p.value === value);
            this.setState({ 
                [name]: { valor: value, nombre: profesionalSeleccionado?.label || "", error: "" } 
            });
            return;
        }
        
        if (type === "checkbox") {
            const previo = this.state[name];
            if (previo && typeof previo === 'object' && Object.prototype.hasOwnProperty.call(previo, 'valor')) {
                this.setState({ [name]: { ...previo, valor: checked, error: "" } });
            } else {
                this.setState({ [name]: checked });
            }
            return;
        }

        if (Object.prototype.hasOwnProperty.call(event.target, 'error')) {
            const previo = this.state[name];
            const valorActual =
                previo && typeof previo === 'object' && Object.prototype.hasOwnProperty.call(previo, 'valor')
                    ? previo.valor
                    : value;

            this.setState({ [name]: { valor: valorActual, error: error || "" } });
            return;
        }

        this.setState({ [name]: { valor: value, error: "" } });
    };

    setFieldError = (name, error = "") => {
        this.setState((prevState) => {
            const previo = prevState[name];
            if (previo && typeof previo === 'object' && Object.prototype.hasOwnProperty.call(previo, 'valor')) {
                return { [name]: { ...previo, error } };
            }

            return { [name]: { valor: previo ?? "", error } };
        });
    };

    validarFormulario = () => {
        const { tipoFormulario, acepta_proteccion_datos } = this.state;
        const { actualizarMensaje } = this.props;
        let valido = true;
        const nuevoEstado = {};
        let mensajeConsentimiento = "";

        if (tipoFormulario === 'asistencia') {
            // Validación formulario de asistencia
            const { nombre_completo, programa, documento, celular, modalidad, tipo_asesoria, forma_asesoria, funcionario_paspe } = this.state;

            if (!nombre_completo.valor || nombre_completo.valor.trim() === "") {
                nuevoEstado.nombre_completo = { ...nombre_completo, error: "El nombre completo es requerido" };
                valido = false;
            }

            if (!programa.valor) {
                nuevoEstado.programa = { ...programa, error: "Debe seleccionar un programa académico" };
                valido = false;
            }

            if (!documento.valor || documento.valor.trim() === "") {
                nuevoEstado.documento = { ...documento, error: "El documento de identidad es requerido" };
                valido = false;
            }

            if (!celular.valor || celular.valor.toString().trim() === "") {
                nuevoEstado.celular = { ...celular, error: "El número de celular es requerido" };
                valido = false;
            }

            if (!modalidad.valor) {
                nuevoEstado.modalidad = { ...modalidad, error: "Debe seleccionar una modalidad" };
                valido = false;
            }

            if (!tipo_asesoria.valor) {
                nuevoEstado.tipo_asesoria = { ...tipo_asesoria, error: "Debe seleccionar el tipo de asesoría" };
                valido = false;
            }

            if (!forma_asesoria.valor) {
                nuevoEstado.forma_asesoria = { ...forma_asesoria, error: "Debe seleccionar la forma de asesoría" };
                valido = false;
            }

            if (!funcionario_paspe.valor || funcionario_paspe.valor.toString().trim() === "") {
                nuevoEstado.funcionario_paspe = { ...funcionario_paspe, error: "Debe ingresar el funcionario PASPE" };
                valido = false;
            }
        } else if (tipoFormulario === 'disentimiento') {
            // Validación formulario de disentimiento
            const { nombre_completo, documento } = this.state;
            const { tipoServicio } = this.props;

            if (!nombre_completo.valor || nombre_completo.valor.trim() === "") {
                nuevoEstado.nombre_completo = { ...nombre_completo, error: "El nombre completo es requerido" };
                valido = false;
            }

            if (!documento.valor || documento.valor.trim() === "") {
                nuevoEstado.documento = { ...documento, error: "El documento de identidad es requerido" };
                valido = false;
            }

            if (!tipoServicio || !tipoServicio.nombre) {
                if (!nuevoEstado.tipo_servicio) {
                    nuevoEstado.tipo_servicio = { error: "Debe tener un tipo de servicio válido" };
                }
                valido = false;
            }

        } else if (tipoFormulario === 'disentimiento_traslado_eps') {
            // Validación global formulario de disentimiento EPS (aplicada al enviar)
            const {
                nombre_completo,
                documento,
                nombre_acudiente,
                numero_identificacion_acudiente,
                reconozco_informacion,
                responsable_atencion,
                comunicacion_decision,
                disposicion_decisiones,
                confirmacion_responsabilidad,
                declaracion_disentimiento,
                importante_aceptacion,
            } = this.state;

            if (!nombre_completo?.valor || nombre_completo.valor.trim() === "") {
                nuevoEstado.nombre_completo = {
                    ...(nombre_completo || { valor: "", error: "" }),
                    error: "El nombre completo es requerido",
                };
                valido = false;
            }

            if (!documento?.valor || documento.valor.trim() === "") {
                nuevoEstado.documento = {
                    ...(documento || { valor: "", error: "" }),
                    error: "El documento de identidad es requerido",
                };
                valido = false;
            }

            if (!nombre_acudiente?.valor || nombre_acudiente.valor.trim() === "") {
                nuevoEstado.nombre_acudiente = {
                    ...(nombre_acudiente || { valor: "", error: "" }),
                    error: "El nombre del acudiente es requerido",
                };
                valido = false;
            }

            if (!numero_identificacion_acudiente?.valor || numero_identificacion_acudiente.valor.trim() === "") {
                nuevoEstado.numero_identificacion_acudiente = {
                    ...(numero_identificacion_acudiente || { valor: "", error: "" }),
                    error: "El número de identificación del acudiente es requerido",
                };
                valido = false;
            }

            if (!reconozco_informacion?.valor) {
                nuevoEstado.reconozco_informacion = {
                    ...(reconozco_informacion || { valor: "", error: "" }),
                    error: "Debe aceptar la información",
                };
                valido = false;
            }

            if (!responsable_atencion?.valor) {
                nuevoEstado.responsable_atencion = {
                    ...(responsable_atencion || { valor: "", error: "" }),
                    error: "Debe seleccionar el profesional",
                };
                valido = false;
            }

            if (!comunicacion_decision?.valor) {
                nuevoEstado.comunicacion_decision = {
                    ...(comunicacion_decision || { valor: "", error: "" }),
                    error: "Debe responder esta pregunta",
                };
                valido = false;
            }

            if (!disposicion_decisiones?.valor) {
                nuevoEstado.disposicion_decisiones = {
                    ...(disposicion_decisiones || { valor: "", error: "" }),
                    error: "Debe responder esta pregunta",
                };
                valido = false;
            }

            if (!confirmacion_responsabilidad?.valor) {
                nuevoEstado.confirmacion_responsabilidad = {
                    ...(confirmacion_responsabilidad || { valor: "", error: "" }),
                    error: "Debe aceptar la responsabilidad",
                };
                valido = false;
            }

            if (!declaracion_disentimiento?.valor) {
                nuevoEstado.declaracion_disentimiento = {
                    ...(declaracion_disentimiento || { valor: "", error: "" }),
                    error: "Debe aceptar la declaración",
                };
                valido = false;
            }

            if (!importante_aceptacion?.valor) {
                nuevoEstado.importante_aceptacion = {
                    ...(importante_aceptacion || { valor: "", error: "" }),
                    error: "Debe aceptar la información importante",
                };
                valido = false;
            }

        } else if (tipoFormulario === 'satisfaccion') {
            // Validación formulario de satisfacción
            const { p1_satisfaccion, p2_temas_pertinentes, p3_estrategias_utiles, p4_comunicacion, 
                    p5_formacion_integral, p6_atencion_servicio, p7_bienestar_emocional } = this.state;

            if (!p1_satisfaccion.valor) {
                nuevoEstado.p1_satisfaccion = { ...p1_satisfaccion, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p2_temas_pertinentes.valor) {
                nuevoEstado.p2_temas_pertinentes = { ...p2_temas_pertinentes, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p3_estrategias_utiles.valor) {
                nuevoEstado.p3_estrategias_utiles = { ...p3_estrategias_utiles, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p4_comunicacion.valor) {
                nuevoEstado.p4_comunicacion = { ...p4_comunicacion, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p5_formacion_integral.valor) {
                nuevoEstado.p5_formacion_integral = { ...p5_formacion_integral, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p6_atencion_servicio.valor) {
                nuevoEstado.p6_atencion_servicio = { ...p6_atencion_servicio, error: "Debe seleccionar una opción" };
                valido = false;
            }

            if (!p7_bienestar_emocional.valor) {
                nuevoEstado.p7_bienestar_emocional = { ...p7_bienestar_emocional, error: "Debe seleccionar una opción" };
                valido = false;
            }
        } else if (tipoFormulario === 'consentimiento' || tipoFormulario === 'consentimiento_crisis') {
            // Validación formularios de consentimiento
            const { nombre_completo_consent, identificacion_consent, celular_consent,
                    contacto_emergencia_1, celular_contacto_1, parentesco_contacto_1,
                    contacto_emergencia_2, celular_contacto_2, parentesco_contacto_2 } = this.state;

            if (!nombre_completo_consent?.valor || nombre_completo_consent.valor.trim() === "") {
                nuevoEstado.nombre_completo_consent = { ...nombre_completo_consent, valor: nombre_completo_consent?.valor || "", error: "El nombre completo es requerido" };
                valido = false;
            }

            if (!identificacion_consent?.valor || identificacion_consent.valor.trim() === "") {
                nuevoEstado.identificacion_consent = { ...identificacion_consent, valor: identificacion_consent?.valor || "", error: "La identificación es requerida" };
                valido = false;
            }

            if (!celular_consent?.valor || celular_consent.valor.toString().trim() === "") {
                nuevoEstado.celular_consent = { ...celular_consent, valor: celular_consent?.valor || "", error: "El celular es requerido" };
                valido = false;
            }

            if (!contacto_emergencia_1?.valor || contacto_emergencia_1.valor.trim() === "") {
                nuevoEstado.contacto_emergencia_1 = { ...contacto_emergencia_1, valor: contacto_emergencia_1?.valor || "", error: "El contacto de emergencia es requerido" };
                valido = false;
            }

            if (!celular_contacto_1?.valor || celular_contacto_1.valor.trim() === "") {
                nuevoEstado.celular_contacto_1 = { ...celular_contacto_1, valor: celular_contacto_1?.valor || "", error: "El celular del contacto es requerido" };
                valido = false;
            }

            if (!parentesco_contacto_1?.valor || parentesco_contacto_1.valor === "") {
                nuevoEstado.parentesco_contacto_1 = { ...parentesco_contacto_1, valor: parentesco_contacto_1?.valor || "", error: "El parentesco es requerido" };
                valido = false;
            }

            if (!contacto_emergencia_2?.valor || contacto_emergencia_2.valor.trim() === "") {
                nuevoEstado.contacto_emergencia_2 = { ...contacto_emergencia_2, valor: contacto_emergencia_2?.valor || "", error: "El segundo contacto de emergencia es requerido" };
                valido = false;
            }

            if (!celular_contacto_2?.valor || celular_contacto_2.valor.trim() === "") {
                nuevoEstado.celular_contacto_2 = { ...celular_contacto_2, valor: celular_contacto_2?.valor || "", error: "El celular del contacto es requerido" };
                valido = false;
            }

            if (!parentesco_contacto_2?.valor || parentesco_contacto_2.valor === "") {
                nuevoEstado.parentesco_contacto_2 = { ...parentesco_contacto_2, valor: parentesco_contacto_2?.valor || "", error: "El parentesco es requerido" };
                valido = false;
            }

            // Validaciones adicionales solo para consentimiento general (no crisis)
            if (tipoFormulario === 'consentimiento') {
                const { tipo_asesoria_individual, tipo_asesoria_consentimiento, consentimiento_aceptado } = this.state;

                if (!tipo_asesoria_individual?.valor) {
                    nuevoEstado.tipo_asesoria_individual = { ...tipo_asesoria_individual, valor: tipo_asesoria_individual?.valor || "", error: "Debe seleccionar el tipo de asesoría individual" };
                    valido = false;
                }

                if (!tipo_asesoria_consentimiento?.valor) {
                    nuevoEstado.tipo_asesoria_consentimiento = { ...tipo_asesoria_consentimiento, valor: tipo_asesoria_consentimiento?.valor || "", error: "Debe seleccionar el tipo de asesoría" };
                    valido = false;
                }

                if (!consentimiento_aceptado?.valor) {
                    nuevoEstado.consentimiento_aceptado = { ...consentimiento_aceptado, valor: consentimiento_aceptado?.valor || false, error: "Debe aceptar el consentimiento" };
                    valido = false;
                    mensajeConsentimiento = mensajeConsentimiento || "Debe aceptar el consentimiento";
                }
            }

            if (tipoFormulario === 'consentimiento_crisis') {
                const { consentimiento_aceptado_crisis } = this.state;
                if (!consentimiento_aceptado_crisis?.valor) {
                    nuevoEstado.consentimiento_aceptado_crisis = { ...consentimiento_aceptado_crisis, valor: consentimiento_aceptado_crisis?.valor || false, error: "Debe aceptar el consentimiento" };
                    valido = false;
                    mensajeConsentimiento = mensajeConsentimiento || "Debe aceptar el consentimiento";
                }
            }
        }

        if (!acepta_proteccion_datos) {
            actualizarMensaje({
                titulo: "Debe aceptar la política de protección de datos",
                tipo: "info",
                mostrar: true,
                tiempo: 4000
            });
            valido = false;
        }

        if (!valido) {
            this.setState(nuevoEstado);
            if (mensajeConsentimiento) {
                actualizarMensaje({
                    titulo: mensajeConsentimiento,
                    tipo: "info",
                    mostrar: true,
                    tiempo: 4000
                });
            }
        }

        return valido;
    };


    validarPasoDisentimientoTrasladoEPS = (pasoActual) => {
        const { actualizarMensaje } = this.props;
        let valido = true;
        const nuevoEstado = {};

        if (pasoActual === 0) {
            const { acepta_proteccion_datos } = this.state;
            if (!acepta_proteccion_datos) {
                if (typeof actualizarMensaje === 'function') {
                    actualizarMensaje({
                        titulo: "Debe aceptar la política de protección de datos para continuar",
                        tipo: "info",
                        mostrar: true,
                        tiempo: 4000,
                    });
                }
                return false; 
            }
        } else if (pasoActual === 2) {
            const { reconozco_informacion, responsable_atencion } = this.state;
            if (!reconozco_informacion?.valor) {
                nuevoEstado.reconozco_informacion = {
                    ...(reconozco_informacion || { valor: "", error: "" }),
                    error: "Debe aceptar la información de este paso",
                };
                valido = false;
            }
            if (!responsable_atencion?.valor) {
                nuevoEstado.responsable_atencion = {
                    ...(responsable_atencion || { valor: "", error: "" }),
                    error: "Debe seleccionar el profesional que lo atendió",
                };
                valido = false;
            }
        } else if (pasoActual === 3) {
            const {
                nombre_acudiente,
                numero_identificacion_acudiente,
                comunicacion_decision,
                disposicion_decisiones,
                confirmacion_responsabilidad,
                declaracion_disentimiento,
                importante_aceptacion,
            } = this.state;

            if (!nombre_acudiente?.valor || nombre_acudiente.valor.trim() === "") {
                nuevoEstado.nombre_acudiente = {
                    ...(nombre_acudiente || { valor: "", error: "" }),
                    error: "El nombre del acudiente es requerido",
                };
                valido = false;
            }

            if (!numero_identificacion_acudiente?.valor || numero_identificacion_acudiente.valor.trim() === "") {
                nuevoEstado.numero_identificacion_acudiente = {
                    ...(numero_identificacion_acudiente || { valor: "", error: "" }),
                    error: "El número de identificación del acudiente es requerido",
                };
                valido = false;
            }

            if (!comunicacion_decision?.valor) {
                nuevoEstado.comunicacion_decision = {
                    ...(comunicacion_decision || { valor: "", error: "" }),
                    error: "Debe responder esta pregunta",
                };
                valido = false;
            }

            if (!disposicion_decisiones?.valor) {
                nuevoEstado.disposicion_decisiones = {
                    ...(disposicion_decisiones || { valor: "", error: "" }),
                    error: "Debe responder esta pregunta",
                };
                valido = false;
            }

            if (!confirmacion_responsabilidad?.valor) {
                nuevoEstado.confirmacion_responsabilidad = {
                    ...(confirmacion_responsabilidad || { valor: "", error: "" }),
                    error: "Debe aceptar la responsabilidad",
                };
                valido = false;
            }

            if (!declaracion_disentimiento?.valor) {
                nuevoEstado.declaracion_disentimiento = {
                    ...(declaracion_disentimiento || { valor: "", error: "" }),
                    error: "Debe aceptar la declaración",
                };
                valido = false;
            }

            if (!importante_aceptacion?.valor) {
                nuevoEstado.importante_aceptacion = {
                    ...(importante_aceptacion || { valor: "", error: "" }),
                    error: "Debe aceptar la información importante",
                };
                valido = false;
            }
        }

        if (!valido) {
            this.setState(nuevoEstado);
            if (typeof actualizarMensaje === 'function') {
                actualizarMensaje({
                    titulo: "Por favor complete los campos obligatorios del paso actual",
                    tipo: "info",
                    mostrar: true,
                    tiempo: 4000,
                });
            }
        }

        return valido;
    };


    validarPasoDisentimiento = (pasoActual) => {
        const { actualizarMensaje } = this.props;
        const nuevoEstado = {};

        if (pasoActual === 0) {
            const { acepta_proteccion_datos } = this.state;
            if (!acepta_proteccion_datos) {
                if (typeof actualizarMensaje === 'function') {
                    actualizarMensaje({
                        titulo: "Debe aceptar la política de protección de datos para continuar",
                        tipo: "info",
                        mostrar: true,
                        tiempo: 4000,
                    });
                }
                return false;
            }
            return true;
        }

        if (pasoActual === 1) {
            const { disentimientoInformado } = this.state;
            if (disentimientoInformado?.valor !== 'SI') {
                nuevoEstado.disentimientoInformado = {
                    ...(disentimientoInformado || { valor: '', error: '' }),
                    error: 'Debe aceptar la declaración de disentimiento para continuar',
                };
                this.setState(nuevoEstado);
                if (typeof actualizarMensaje === 'function') {
                    actualizarMensaje({
                        titulo: "Debe aceptar la declaración de disentimiento para continuar",
                        tipo: "info",
                        mostrar: true,
                        tiempo: 4000,
                    });
                }
                return false;
            }
        }

        return true;
    };

    enviarFormulario = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const tipoFormulario = this.props.tipoFormulario || this.state.tipoFormulario;

        if (tipoFormulario === 'disentimiento') {
            const r = procesarFirmas(null, this.firmaDisentimientoAcudiente, false);
            if (!r.valido) {
                if (typeof this.props.actualizarMensaje === 'function') {
                    this.props.actualizarMensaje({
                        titulo: r.errores[0] || 'Debe firmar el documento como acudiente o representante',
                        tipo: 'info',
                        mostrar: true,
                        tiempo: 4000,
                    });
                }
                return;
            }
            this._firmaPayloadDisentimiento = r.firmas;
        } else if (tipoFormulario === 'disentimiento_traslado_eps') {
            const r = procesarFirmasEstudianteAcudiente(
                this.firmaTrasladoEstudiante,
                this.firmaTrasladoAcudiente,
            );
            if (!r.valido) {
                if (typeof this.props.actualizarMensaje === 'function') {
                    this.props.actualizarMensaje({
                        titulo: r.errores[0] || 'Debe completar ambas firmas',
                        tipo: 'info',
                        mostrar: true,
                        tiempo: 4000,
                    });
                }
                return;
            }
            this._firmaPayloadTraslado = r.firmas;
        }

        try {
            this.setState({ cargando: true });
            const { acepta_proteccion_datos } = this.state;
            const { bienestar_id, sesion } = this.props;
            
            const sesionNumero = (() => {
                if (!sesion) return null;
                
                // Mapeo de texto a número para sesiones en español
                const mapeoSesiones = {
                    'primera': 1, 'primero': 1, 'pri': 1, '1': 1,
                    'segunda': 2, 'segundo': 2, 'seg': 2, '2': 2,
                    'tercera': 3, 'tercero': 3, 'ter': 3, '3': 3,
                    'cuarta': 4, 'cuarto': 4, 'cua': 4, '4': 4,
                    'quinta': 5, 'quinto': 5, 'qui': 5, '5': 5,
                    'sexta': 6, 'sexto': 6, 'sex': 6, '6': 6,
                    'septima': 7, 'septimo': 7, 'sep': 7, '7': 7,
                    'octava': 8, 'octavo': 8, 'oct': 8, '8': 8,
                };
                
                // Intentar desde nombre (ej: "PRIMERA SESIÓN")
                const nombre = (sesion?.nombre ?? '').toString().toLowerCase();
                for (const [key, val] of Object.entries(mapeoSesiones)) {
                    if (nombre.includes(key)) return val;
                }
                
                // Intentar desde codigo (ej: "pri_se_bien")
                const codigo = (sesion?.codigo ?? '').toString().toLowerCase();
                for (const [key, val] of Object.entries(mapeoSesiones)) {
                    if (codigo.includes(key)) return val;
                }
                
                // Intentar extraer número directo de valorc, valor, etc.
                const raw = sesion?.valorc ?? sesion?.valor ?? sesion?.valora ?? '';
                if (raw && raw !== 'null') {
                    const n = parseFloat(raw);
                    if (!isNaN(n)) return n;
                }
                
                // Intentar extraer primer número del nombre o código
                const match = (nombre + ' ' + codigo).match(/\d+/);
                if (match) {
                    const n = parseInt(match[0], 10);
                    if (!isNaN(n)) return n;
                }
                
                return null;
            })();

            let data = {
                bienestar: bienestar_id,
                sesion_numero: sesionNumero,
                tipo_formulario: tipoFormulario,
                acepta_proteccion_datos: acepta_proteccion_datos ? true : false
            };

            if (tipoFormulario === 'asistencia') {
                const { nombre_completo, programa, documento, celular, modalidad, tipo_asesoria, forma_asesoria, funcionario_paspe } = this.state;
                data = {
                    ...data,
                    nombre_completo: nombre_completo.valor,
                    programa: programa.valor,
                    documento: documento.valor,
                    celular: celular.valor,
                    modalidad: modalidad.valor,
                    tipo_asesoria: tipo_asesoria.valor,
                    forma_asesoria: forma_asesoria.valor,
                    funcionario_paspe: funcionario_paspe.nombre || funcionario_paspe.valor
                };
            } else if (tipoFormulario === 'disentimiento') {
                const { nombre_completo, documento } = this.state;
                const { tipoServicio } = this.props;
                data = {
                    ...data,
                    nombre_completo: nombre_completo?.valor || '',
                    documento: documento?.valor || '',
                    tipo_servicio: tipoServicio?.id || tipoServicio?.codigo || tipoServicio?.valor || tipoServicio?.nombre || '',
                    firma_acudiente: this._firmaPayloadDisentimiento?.firma_responsable || '',
                };
            } else if (tipoFormulario === 'disentimiento_traslado_eps') {
                const {
                    nombre_completo,
                    documento,
                    nombre_acudiente,
                    numero_identificacion_acudiente,
                    comunicacion_decision,
                    disposicion_decisiones,
                    reconozco_informacion,
                    responsable_atencion,
                    confirmacion_responsabilidad,
                    declaracion_disentimiento,
                    importante_aceptacion,
                } = this.state;
                const { tipoServicio } = this.props;

                const mapSiNoToBoolString = (v) => {
                    const val = (v || '').toString().trim().toUpperCase();
                    if (val === 'SI') return 'True';
                    if (val === 'NO') return 'False';
                    return '';
                };

                data = {
                    ...data,
                    nombre_completo: nombre_completo?.valor || '',
                    documento: documento?.valor || '',
                    tipo_servicio: tipoServicio?.id || tipoServicio?.codigo || tipoServicio?.valor || tipoServicio?.nombre || '',
                    nombre_acudiente: nombre_acudiente?.valor || '',
                    numero_identificacion_acudiente: numero_identificacion_acudiente?.valor || '',
                    comunicacion_decision: mapSiNoToBoolString(comunicacion_decision?.valor),
                    disposicion_decisiones: mapSiNoToBoolString(disposicion_decisiones?.valor),
                    reconozco_informacion: mapSiNoToBoolString(reconozco_informacion?.valor),
                    responsable_atencion: responsable_atencion?.valor || '',
                    confirmacion_responsabilidad: mapSiNoToBoolString(confirmacion_responsabilidad?.valor),
                    declaracion_disentimiento: mapSiNoToBoolString(declaracion_disentimiento?.valor),
                    importante_aceptacion: mapSiNoToBoolString(importante_aceptacion?.valor),
                    firma_estudiante: this._firmaPayloadTraslado?.firma_estudiante || '',
                    firma_acudiente: this._firmaPayloadTraslado?.firma_acudiente || '',
                };
            } else if (tipoFormulario === 'satisfaccion') {
                const {
                    p1_satisfaccion, p1_comentario_satisfaccion, p2_temas_pertinentes, p2_comentario_temas,
                    p3_estrategias_utiles, p3_comentario_estrategias, p4_comunicacion, p4_comentario_comunicacion,
                    p5_formacion_integral, p5_comentario_formacion, p6_atencion_servicio, p6_comentario_atencion,
                    p7_bienestar_emocional, p7_comentario_bienestar, p8_mejoras
                } = this.state;

                data = {
                    ...data,
                    p1_satisfaccion: p1_satisfaccion.valor,
                    p1_comentario_satisfaccion: p1_comentario_satisfaccion.valor,
                    p2_temas_pertinentes: p2_temas_pertinentes.valor,
                    p2_comentario_temas: p2_comentario_temas.valor,
                    p3_estrategias_utiles: p3_estrategias_utiles.valor,
                    p3_comentario_estrategias: p3_comentario_estrategias.valor,
                    p4_comunicacion: p4_comunicacion.valor,
                    p4_comentario_comunicacion: p4_comentario_comunicacion.valor,
                    p5_formacion_integral: p5_formacion_integral.valor,
                    p5_comentario_formacion: p5_comentario_formacion.valor,
                    p6_atencion_servicio: p6_atencion_servicio.valor,
                    p6_comentario_atencion: p6_comentario_atencion.valor,
                    p7_bienestar_emocional: p7_bienestar_emocional.valor,
                    p7_comentario_bienestar: p7_comentario_bienestar.valor,
                    p8_mejoras: p8_mejoras.valor
                };
            } else if (tipoFormulario === 'consentimiento' || tipoFormulario === 'consentimiento_crisis') {
                const {
                    tipo_asesoria_individual, tipo_asesoria_consentimiento,
                    nombre_completo_consent, identificacion_consent, celular_consent,
                    contacto_emergencia_1, celular_contacto_1, parentesco_contacto_1,
                    contacto_emergencia_2, celular_contacto_2, parentesco_contacto_2,
                    consentimiento_aceptado, consentimiento_aceptado_crisis
                } = this.state;

                data = {
                    ...data,
                    // Se envían ambos nombres de campos para compatibilidad con backend
                    nombre_completo_consent: nombre_completo_consent.valor,
                    nombre_completo: nombre_completo_consent.valor,
                    identificacion_consent: identificacion_consent.valor,
                    identificacion: identificacion_consent.valor,
                    celular_consent: celular_consent.valor,
                    celular: celular_consent.valor,
                    contacto_emergencia_1: contacto_emergencia_1.valor,
                    celular_contacto_1: celular_contacto_1.valor,
                    parentesco_contacto_1: parentesco_contacto_1.valor,
                    contacto_emergencia_2: contacto_emergencia_2.valor,
                    celular_contacto_2: celular_contacto_2.valor,
                    parentesco_contacto_2: parentesco_contacto_2.valor
                };

                // Solo para consentimiento general (no crisis)
                if (tipoFormulario === 'consentimiento') {
                    data.tipo_asesoria_individual = tipo_asesoria_individual.valor;
                    data.tipo_asesoria_consentimiento = tipo_asesoria_consentimiento.valor;
                    data.consentimiento_aceptado = !!consentimiento_aceptado?.valor;
                }

                if (tipoFormulario === 'consentimiento_crisis') {
                    data.consentimiento_aceptado_crisis = !!consentimiento_aceptado_crisis?.valor;
                }
            }

            const { error, estado, resp } = await postFormatoBienestar(bienestar_id, tipoFormulario, data);
            this.setState({ cargando: false });
            if (!error && (estado === 200 || estado === 201)) {
                this.props.actualizarMensaje({
                    titulo: resp?.mensaje || "Formato enviado correctamente",
                    tipo: "success",
                    mostrar: true,
                    tiempo: 4000
                });
                if (typeof this.props.onSuccess === 'function') {
                    this.props.onSuccess();
                }
                this.cerrarModal();
            } else {
                const mensajeError = resp?.mensaje || resp?.titulo || resp?.detail || "Error al enviar el formato";
                this.props.actualizarMensaje({
                    titulo: mensajeError,
                    tipo: "danger",
                    mostrar: true,
                    tiempo: 4000
                });
            }
        } catch (error) {
            this.setState({ cargando: false });
            this.props.actualizarMensaje({
                titulo: "Error al procesar el formulario",
                tipo: "danger",
                mostrar: true,
                tiempo: 4000
            });
        }
    };

    cerrarModal = () => {
        this.resetState();
        if (typeof this.props.mostrarModal === 'function') {
            this.props.mostrarModal(false);
        }
    };

    resetState = (callback) => {
        this.setState((prevState) => {
            const nuevoEstado = {
                acepta_proteccion_datos: false,
                acepta_terminos: { valor: false, error: "" },
                paso_disentimiento: 0,
                paso_disentimiento_traslado_eps: 0,
            };

            Object.keys(prevState).forEach((key) => {
                if (key === 'acepta_proteccion_datos' || key === 'acepta_terminos' || key === 'paso_disentimiento' || key === 'paso_disentimiento_traslado_eps') return;

                const valor = prevState[key];
                if (
                    valor &&
                    typeof valor === 'object' &&
                    Object.prototype.hasOwnProperty.call(valor, 'valor')
                ) {
                    nuevoEstado[key] = {
                        ...valor,
                        valor: typeof valor.valor === 'boolean' ? false : "",
                        error: "",
                    };
                }
            });

            return nuevoEstado;
        }, callback);
    };

    conError = (error) => {
        return error && error !== "";
    };

    pintarSelect = (label, name, opciones, required = true) => {
        const field = this.state[name];
        const opts = Array.isArray(opciones) ? opciones : [];
        return (
            <FormControl fullWidth error={this.conError(field && field.error)} required={required}>
                <InputLabel>{label}</InputLabel>
                <Select
                    name={name}
                    value={field && field.valor ? field.valor : ""}
                    onChange={this.onChange}
                >
                    {opts.map((op) => (
                        <MenuItem key={op.value} value={op.value}>
                            {op.label}
                        </MenuItem>
                    ))}
                </Select>
                {field && field.error && <FormHelperText>{field.error}</FormHelperText>}
            </FormControl>
        );
    };


    renderFormulario = () => {
            const { 
                tipoServicio,
                fichaSeleccionada,
                bienestar_id,
                actualizarMensaje,
                mostrarModal,
                solicitud,
                onSuccess,
                modoLectura,
                esVistaEstudiante,
                moduloSeleccionado,
             } = this.props;
            const {
                tipoFormulario,
                programa_opciones,
                modalidad_opciones,
                tipo_asesoria_opciones,
                tipo_asesoria_consent_opciones,
                forma_asesoria_opciones,
                parentesco_opciones,
                profesionales_opciones,
                modalidadAutoLlenada,
                consentimiento_aceptado,
                consentimiento_aceptado_crisis,
                texto_proteccion_datos,
                acepta_proteccion_datos,
                paso_disentimiento,
                paso_disentimiento_traslado_eps,
            } = this.state;

            const opcionesMaestro = {
                programas: programa_opciones,
                profesionales: profesionales_opciones,
                parentescos: parentesco_opciones
            };
            switch (tipoFormulario) {
                case 'asistencia':
                    return (
                        <>
                            <FormularioAsistencia
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                                pintarSelect={this.pintarSelect}
                                programaOpciones={programa_opciones}
                                modalidadOpciones={modalidad_opciones}
                                tipoAsesoriasOpciones={tipo_asesoria_opciones}
                                formasAsesoriasOpciones={forma_asesoria_opciones}
                                profesionalesOpciones={profesionales_opciones}
                                modalidadAutoLlenada={modalidadAutoLlenada}
                                profesionalDisabled={false}
                            />
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                        </>
                    );

                case 'disentimiento':
                    return (
                        <>
                            <FormularioDisentimientoInformado
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                                servicio={tipoServicio}
                                firmaRefAcudiente={this.firmaDisentimientoAcudiente}
                                limpiarFirmaAcudiente={this.limpiarFirmaCanvas}
                                ProteccionDatosComponent={
                                    <ProteccionDatos
                                        texto={texto_proteccion_datos}
                                        value={acepta_proteccion_datos}
                                        onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                                    />
                                }
                                activeStep={paso_disentimiento || 0}
                            />
                        </>
                    );

                case 'disentimiento_traslado_eps':
                    return (
                        <>
                            <FormularioDisentimientoTrasladoEPS
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                                servicio={tipoServicio}
                                profesionalesOpciones={profesionales_opciones}
                                ProteccionDatosComponent={
                                    <ProteccionDatos
                                        texto={texto_proteccion_datos}
                                        value={acepta_proteccion_datos}
                                        onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                                    />
                                }
                                activeStep={paso_disentimiento_traslado_eps || 0}
                                firmaRefEstudiante={this.firmaTrasladoEstudiante}
                                firmaRefAcudiente={this.firmaTrasladoAcudiente}
                                limpiarFirma={this.limpiarFirmaCanvas}
                            />
                        </>
                    );

                case 'satisfaccion':
                    return (
                        <>
                            <FormularioSatisfaccion
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                            />
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                        </>
                    );

                case 'consentimiento':
                    return (
                        <>
                            <TextoConsentimiento 
                                state={this.state}
                                tipo="general" 
                                fieldName="consentimiento_aceptado"
                                aceptado={consentimiento_aceptado?.valor}
                                onChange={this.onChange}
                            />
                            <FormularioConsentimientoGeneral
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                                pintarSelect={this.pintarSelect}
                                programaOpciones={programa_opciones}
                                tipoAsesoriasOpciones={tipo_asesoria_consent_opciones}
                                formasAsesoriasOpciones={forma_asesoria_opciones}
                                parentescosOpciones={parentesco_opciones}
                            />
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                        </>
                    );

                case 'consentimiento_crisis':
                    return (
                        <>
                            <TextoConsentimiento 
                                state={this.state}
                                tipo="crisis" 
                                fieldName="consentimiento_aceptado_crisis"
                                aceptado={consentimiento_aceptado_crisis?.valor}
                                onChange={this.onChange}
                            />
                            <FormularioConsentimientoCrisis
                                state={this.state}
                                onChange={this.onChange}
                                onError={this.conError}
                                parentescosOpciones={parentesco_opciones}
                            />
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                        </>
                    );

                case 'F1_001':
                case 'F2_002':
                case 'F2_003':
                case 'F2_004':
                case 'F2_005':
                case 'F3_006':
                case 'F5_007':
                case 'F5_008':
                case 'F6_009':
                case 'T_1':
                case 'T_2':
                case 'T_3':
                case 'T_4':
                case 'T_5':
                    // Si viene información del módulo seleccionado (secundario), usar sus valora/b/c
                    const moduloSeleccionadoData = moduloSeleccionado || {};
                    const meta = moduloSeleccionadoData.secundario || {};
                    const { fase } = this.props;
                    return (
                        <FormularioMaestroFasesConAcciones
                            key={tipoFormulario}
                            formId={tipoFormulario}
                            state={this.state}
                            onChange={this.onChange}
                            pintarSelect={this.pintarSelect}
                            opciones={opcionesMaestro}
                            onEnviar={this.enviarFormulario}
                            bienestarId={bienestar_id}
                            solicitud={solicitud}
                            actualizarMensaje={actualizarMensaje}
                            mostrarModal={this.cerrarModal}
                            onSuccess={onSuccess}
                            valora={meta.valora}
                            valorb={meta.valorb}
                            valorc={meta.valorc}
                            valord={meta.valord}
                            fase={fase}
                            texto_proteccion_datos={texto_proteccion_datos}
                            setFieldError={this.setFieldError}
                            onError={this.conError}
                            profesionales_opciones={profesionales_opciones}
                            ProteccionDatosComponent={
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                            }
                        />
                    );

                case 'ficha_seguimiento':
                    return (
                        <FormularioFichaSeguimientoConAcciones
                            tipoServicio={tipoServicio}
                            pintarSelect={this.pintarSelect}
                            opciones={opcionesMaestro}
                            onEnviar={this.enviarFormulario}
                            texto_proteccion_datos={texto_proteccion_datos}
                            fichaSeleccionada={fichaSeleccionada}
                            bienestarId={bienestar_id}
                            actualizarMensaje={actualizarMensaje}
                            mostrarModal={mostrarModal}
                            solicitud={solicitud}
                            onSuccess={onSuccess}
                            profesionales_opciones={profesionales_opciones}
                            modoLectura={modoLectura}
                            puedeCerrarFicha={!esVistaEstudiante && !modoLectura}
                            ProteccionDatosComponent={
                            <ProteccionDatos
                                texto={texto_proteccion_datos}
                                value={acepta_proteccion_datos}
                                onChange={(val) => this.setState({ acepta_proteccion_datos: val })}
                            />
                            }
                        />
                    );

                default:
                    return null;
            }
        };



    render() {
        const { modalOpen, titulo} = this.props;
        const {
            cargando,
            tipoFormulario,
            acepta_proteccion_datos,
            texto_proteccion_datos,
            paso_disentimiento,
            paso_disentimiento_traslado_eps
        } = this.state;

        let tituloModal = titulo;
        if (!tituloModal) {
            if (tipoFormulario === 'asistencia') tituloModal = 'Formato de Asistencia';
            else if (tipoFormulario === 'satisfaccion') tituloModal = 'Formato de Satisfacción';
            else if (tipoFormulario === 'consentimiento') tituloModal = 'Consentimiento Informado - Asesoría Individual';
            else if (tipoFormulario === 'consentimiento_crisis') tituloModal = 'Consentimiento Informado - Atención en Crisis';
            else if (tipoFormulario === 'disentimiento') tituloModal = 'Disentimiento Informado';

            // fases 
            else if (tipoFormulario === 'F1_001') tituloModal = 'Atención de la Emergencia';
            else if (tipoFormulario === 'F2_002') tituloModal = 'Consentimiento informado para la activación de la RUTA VBG';
            else if (tipoFormulario === 'F2_003') tituloModal = 'Consentimiento Informado para la Recepción de Entrevistas de la Ruta VBG';
            else if (tipoFormulario === 'F2_004') tituloModal = 'Consentimiento informado para la recepción de entrevista terceros';
            else if (tipoFormulario === 'F2_005') tituloModal = 'Entrevistas ruta de atención VBG';
            else if (tipoFormulario === 'F3_006') tituloModal = 'Ruta de atención acompañamiento integral pedagógico';
            else if (tipoFormulario === 'F5_007') tituloModal = 'Ruta de atención medidas restaurativas de la persona afectada';
            else if (tipoFormulario === 'F5_008') tituloModal = 'Ruta de atención socialización medidas restaurativas persona ofensora';
            else if (tipoFormulario === 'F6_009') tituloModal = 'Ruta de atención seguimiento a la implementación de la ruta.';
            else if (tipoFormulario === 'T_1') tituloModal = 'Acta archivo definitivo';
            else if (tipoFormulario === 'T_2') tituloModal = 'Acta de archivo provisional';
            else if (tipoFormulario === 'T_3') tituloModal = 'Desistimiento Ruta de atención VBG';
            else if (tipoFormulario === 'T_4') tituloModal = 'Psicoeducación';
            else if (tipoFormulario === 'T_5') tituloModal = 'Comunicación cierre ruta';

            else tituloModal = 'Formato de Bienestar';
        }

        const formatear = (t = "") =>
        t.replace(/\. /g, ".\n\n");


        const esFormularioValido = this.esFormularioValido();
        const esDisentimientoTrasladoEPS = tipoFormulario === 'disentimiento_traslado_eps';
        const esDisentimientoSimple = tipoFormulario === 'disentimiento';
        const pasoActualDisentimiento = paso_disentimiento || 0;
        const pasoActualDisentimientoEPS = paso_disentimiento_traslado_eps || 0;
        return (
            <Dialog
                open={modalOpen || false}
                maxWidth="md"
                fullWidth
                scroll="paper"
                onClose={this.cerrarModal}
                PaperProps={{ style: FORMATO_BIENESTAR_DIALOG_PAPER }}
            >
                <AppBarModal titulo={`¡ ${tituloModal} !`} mostrarModal={this.cerrarModal} titulo_accion="" />
                <DialogContent
                    style={{
                        flex: '1 1 auto',
                        minHeight: 0,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        padding: 16,
                        width: '100%',
                        boxSizing: 'border-box',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    {cargando ? (
                        <TareasTerminadas
                            mensaje="Cargando..."
                            marginTop="7%"
                            imagen={emma_w}
                            widthImg="7%"
                            cargando={true}
                        />
                    ) : (
                        <>
                        {this.renderFormulario()}
                        </>
                    )}
                </DialogContent>
                {esFormularioValido ? null : (
                    <>
                        <DialogActions
                            style={{
                                flexShrink: 0,
                                flexWrap: 'wrap',
                                justifyContent: 'flex-end',
                                gap: 8,
                                padding: '12px 16px 16px',
                                borderTop: '1px solid rgba(0,0,0,0.08)',
                            }}
                        >
                            {esDisentimientoTrasladoEPS ? (
                                <>
                                    {pasoActualDisentimientoEPS > 0 && (
                                        <Button
                                            disabled={false}
                                            onClick={() =>
                                                this.setState(prev => ({
                                                    paso_disentimiento_traslado_eps: (prev.paso_disentimiento_traslado_eps || 0) - 1,
                                                }))
                                            }
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: 10 }}
                                        >
                                            Atrás
                                        </Button>
                                    )}
                                    {pasoActualDisentimientoEPS < 4 ? (
                                        <Button
                                            onClick={() => {
                                                // Validación por paso antes de avanzar en el wizard EPS
                                                if (this.validarPasoDisentimientoTrasladoEPS(pasoActualDisentimientoEPS)) {
                                                    this.setState(prev => ({
                                                        paso_disentimiento_traslado_eps: (prev.paso_disentimiento_traslado_eps || 0) + 1,
                                                    }));
                                                }
                                            }}
                                            variant="contained"
                                            color="primary"
                                            disabled={cargando}
                                        >
                                            Siguiente
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.enviarFormulario}
                                            disabled={cargando}
                                        >
                                            Enviar
                                        </Button>
                                    )}
                                </>
                            ) : esDisentimientoSimple ? (
                                <>
                                    {pasoActualDisentimiento > 0 && (
                                        <Button
                                            disabled={false}
                                            onClick={() =>
                                                this.setState(prev => ({
                                                    paso_disentimiento: (prev.paso_disentimiento || 0) - 1,
                                                }))
                                            }
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: 10 }}
                                        >
                                            Atrás
                                        </Button>
                                    )}
                                    {pasoActualDisentimiento < 2 ? (
                                        <Button
                                            onClick={() => {
                                                if (this.validarPasoDisentimiento(pasoActualDisentimiento)) {
                                                    this.setState(prev => ({
                                                        paso_disentimiento: (prev.paso_disentimiento || 0) + 1,
                                                    }));
                                                }
                                            }}
                                            variant="contained"
                                            color="primary"
                                            disabled={cargando}
                                        >
                                            Siguiente
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.enviarFormulario}
                                            disabled={cargando}
                                        >
                                            Enviar
                                        </Button>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={this.cerrarModal}
                                        style={{ marginRight: 10 }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.enviarFormulario}
                                        disabled={cargando}
                                    >
                                        Enviar
                                    </Button>
                                </>
                            )}
                        </DialogActions>
                    </>
                )}
            </Dialog>
        );
    }
}

BienestarFormFormatos.defaultProps = {
    modoLectura: false,
    esVistaEstudiante: false,
};

export default BienestarFormFormatos;
